import { useForm, Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Account { id: number; name: string; slug: string }
interface Props {
  account: Account
  errors?: string[]
  permissions?: { can_manage_branches: boolean }
}

export default function BranchesNew({ account, errors, permissions }: Props) {
  const { data, setData, post, processing } = useForm({
    name: '',
    address: '',
    phone: '',
    schedule: '',
    is_active: true,
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/${account.slug}/branches`)
  }

  return (
    <Layout account={account} permissions={permissions}>
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-[#202020] mb-6">Nueva Sucursal</h1>

        {errors && errors.length > 0 && (
          <div className="bg-red-50 text-red-600 p-3 rounded mb-4">
            {errors.map((error, i) => <p key={i}>{error}</p>)}
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
            <input type="text" value={data.name} onChange={(e) => setData('name', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              required />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Dirección</label>
            <input type="text" value={data.address} onChange={(e) => setData('address', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
            <input type="text" value={data.phone} onChange={(e) => setData('phone', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Horario</label>
            <input type="text" value={data.schedule} onChange={(e) => setData('schedule', e.target.value)}
              placeholder="Lun-Vie 9:00-18:00"
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
          </div>
          <div className="flex items-center">
            <input type="checkbox" id="is_active" checked={data.is_active}
              onChange={(e) => setData('is_active', e.target.checked)}
              className="mr-2" />
            <label htmlFor="is_active" className="text-sm text-gray-700">Sucursal activa</label>
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Link href={`/${account.slug}/branches`}
              className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50">Cancelar</Link>
            <button type="submit" disabled={processing}
              className="bg-[#FFC107] text-[#202020] px-4 py-2 rounded font-semibold hover:bg-[#e6ad06] disabled:opacity-50">
              {processing ? 'Guardando...' : 'Crear Sucursal'}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  )
}
